/* eslint-disable */

const customSelect = () => {
  const filterContentShops = (capacity) => {
    const allRenderedLists = document.querySelectorAll('.js-shop-wrap-partner');
    if (allRenderedLists) {
      allRenderedLists.forEach((el) => el.classList.remove('active'));
      allRenderedLists.forEach((list) => {
        const marker = list.getAttribute('data-capacity');
        if (marker == capacity) list.classList.add('active');
      });
    }
  };

  let x;
  let i;
  let j;
  let l;
  let ll;
  let selElmnt;
  let a;
  let b;
  let c;
  /* Look for any elements with the class "custom-select": */
  x = document.getElementsByClassName('custom-select');
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName('select')[0];
    const isCapacityFilter = x[i].classList.contains(
      'js-change-capacity-shops',
    );
    const isArchiveSelect = x[i].classList.contains('js-change-archive-page');
    ll = selElmnt.length;
    a = document.createElement('DIV');
    a.setAttribute('class', 'select-selected');
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
    x[i].appendChild(a);
    /* For each element, create a new DIV that will contain the option list: */
    b = document.createElement('DIV');
    b.setAttribute('class', 'select-items select-hide');
    for (j = 0; j < ll; j++) {
      /* For each option in the original select element,
    create a new DIV that will act as an option item: */
      c = document.createElement('DIV');
      c.innerHTML = selElmnt.options[j].innerHTML;
      if (selElmnt.options[j].value)
        c.setAttribute('data-value', selElmnt.options[j].value);
      let isClass = selElmnt.options[j].className;
      if(isClass){
        c.classList.add(isClass);
      }
      c.addEventListener('click', function (e) {
        /* When an item is clicked, update the original select box,
        and the selected item: */
        let y;
        let i;
        let k;
        let s;
        let h;
        let sl;
        let yl;
        s = this.parentNode.parentNode.getElementsByTagName('select')[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            if (this.getAttribute('data-value'))
              h.setAttribute('data-value', this.getAttribute('data-value'));
            if (isCapacityFilter && this.getAttribute('data-value')) {
              filterContentShops(this.getAttribute('data-value'));

              const target = this.getAttribute('data-value');
              const customSelShop = document.querySelectorAll(
                '.custom-select.js-change-capacity-shops .select-items div',
              );

              if (customSelShop) {
                customSelShop.forEach((el) => {
                  const childVal = el.getAttribute('data-value');
                  if (
                    childVal == target &&
                    !el.classList.contains('same-as-selected')
                  )
                    el.click();
                });
              }
            }

            if(isArchiveSelect && this.getAttribute('data-value')){
               window.location = this.getAttribute('data-value');
            }
            y = this.parentNode.getElementsByClassName('same-as-selected');
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute('class');
            }
            this.setAttribute('class', 'same-as-selected');
            break;
          }
        }
        h.click();
      });
      b.appendChild(c);
    }
    x[i].appendChild(b);
    a.addEventListener('click', function (e) {
      /* When the select box is clicked, close any other select boxes,
    and open/close the current select box: */
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle('select-hide');
      this.classList.toggle('select-arrow-active');
    });
  }

  function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
  except the current select box: */
    let x;
    let y;
    let i;
    let xl;
    let yl;
    const arrNo = [];
    x = document.getElementsByClassName('select-items');
    y = document.getElementsByClassName('select-selected');
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i);
      } else {
        y[i].classList.remove('select-arrow-active');
      }
    }
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add('select-hide');
      }
    }
  }

  /* If the user clicks anywhere outside the select box,
then close all select boxes: */
  document.addEventListener('click', closeAllSelect);
};

export default customSelect;
